module.exports = __webpack_public_path__ + "img/4554d76bdd9e745de4e10f58ba5875a.5c61dffb.png";